import { BIModel } from './BIModel';

export class ProductListSwitchBIModel extends BIModel {

    static eventName = 'product_list_switch';

    #changeTo;
    #flow;
    
    constructor(userId, changeTo, flow) {
        super(ProductListSwitchBIModel.eventName, userId);
        this.#changeTo = changeTo;
        this.#flow = flow
    }

    get changeTo() {
        return this.#changeTo;
    }

    get flow() {
        return this.#flow;
    }

    get modelData() {
        return {
            change_to: this.changeTo,
            flow: this.flow
          };
    }

}